// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'backspace-solid';

export const Component = () => (
  <path d='m17.715 8.257-2.97 2.921-2.92-2.921-.72.67 2.97 2.97-2.97 2.921.72.719 2.92-2.97 2.97 2.97.67-.719-2.92-2.921 2.92-2.97-.67-.67Zm3.927 10.488H8.855L1 11.945 8.855 5h12.787c.527 0 1.006.191 1.39.575.383.384.574.862.574 1.39v9.817c0 .527-.191 1.006-.575 1.39a1.917 1.917 0 0 1-1.389.574Z' />
);

export const viewBox = '0 0 25 25';
